_BannerFlowApp.directive("selectAll", function () {
    return {
        priority: 0,
        restrict: "A",
        replace: false,
        link: function (scope, element, attrs) {
            element.focus(function () {
                element[0].select();

                element[0].onmouseup = function () {
                    element[0].onmouseup = null;
                    return false;
                };
            });
        }
    };
});
